export default __webpack_public_path__ + "static/media/back.2e8d90d4.svg";